// "As featured in" press-logo marquee. JobTest's own brand-press logos,
// served from the same Webflow CDN as jobtest.org/career-test & /testing.
// Infinite scroll via the global `ac-marquee` keyframe (src/styles/globals.css),
// pausing + wrapping to a centered row for reduced-motion users.

const FEATURED_LOGOS: { name: string; src: string }[] = [
  { name: 'NBC', src: 'https://cdn.prod.website-files.com/63b58014b3cc40403185e35e/65819c1ffcf8ca3e381e7c20_nbc.svg' },
  { name: 'Fox', src: 'https://cdn.prod.website-files.com/63b58014b3cc40403185e35e/65819c12414085c8cb4d7d49_fox.svg' },
  { name: 'CBS', src: 'https://cdn.prod.website-files.com/63b58014b3cc40403185e35e/65819bef7d0ec2566e37afc5_cbs.svg' },
  { name: 'ABC', src: 'https://cdn.prod.website-files.com/63b58014b3cc40403185e35e/65819bdf2dbf4e270ebade91_abc.svg' },
  { name: 'PACE', src: 'https://cdn.prod.website-files.com/63b58014b3cc40403185e35e/65819c2c3a3a4b1eaf3c6585_pace.svg' },
  { name: 'CUNY', src: 'https://cdn.prod.website-files.com/63b58014b3cc40403185e35e/65819bfb74bc333c5b325946_cuny.svg' },
  { name: 'Digital Journal', src: 'https://cdn.prod.website-files.com/63b58014b3cc40403185e35e/65819c08380a269498642611_diigtaljournal.svg' },
];

export function FeaturedLogos({ label = 'As featured in' }: { label?: string }) {
  const loop = [...FEATURED_LOGOS, ...FEATURED_LOGOS];
  return (
    <div>
      <p className="eyebrow text-center mb-4">{label}</p>
      <div
        className="relative overflow-hidden"
        style={{
          maskImage: 'linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)',
          WebkitMaskImage: 'linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)',
        }}
      >
        <ul className="flex w-max items-center gap-10 sm:gap-16 animate-[ac-marquee_32s_linear_infinite] motion-reduce:animate-none motion-reduce:w-full motion-reduce:flex-wrap motion-reduce:justify-center motion-reduce:gap-8">
          {loop.map((logo, i) => (
            <li key={`${logo.name}-${i}`} className="flex-shrink-0">
              <img
                src={logo.src}
                alt={logo.name}
                className="h-6 sm:h-8 w-auto opacity-50 grayscale transition hover:opacity-100 hover:grayscale-0"
                loading="lazy"
                aria-hidden={i >= FEATURED_LOGOS.length}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
